import {GuestApi} from "../../common/api/const";

export class ShareApiService {
    static fetchSharedCv = (cvId: string) => GuestApi().get(`/share/users/${cvId}`);
}